export default __webpack_public_path__ + "static/flag-us-e243151f31b46a131848eec43fee3381.svg";